<form [formGroup]="templateForm">
  <div class="form-row row">
    <div class="form-group col-md-4">
      <label for="templateName" class="control-label required">{{ 'i18n.shared.template-name' | translate }}</label>
      <input id="templateName" type="text" class="form-control" formControlName="templateName" />
      <app-error-messages [control]="templateForm.controls.templateName"></app-error-messages>
    </div>
    <div class="form-group col-md-4">
      <label for="configurationType" class="control-label required">{{ 'i18n.shared.configuration-type' | translate }}</label>
      <app-enum-drop-down-list [formControl]="templateForm.controls.configurationType"
                               [showClearButton]="false"
                               [enumType]="Type"
                               baseTranslationString='i18n.shared.configurationTypes.'>
      </app-enum-drop-down-list>
      <app-error-messages [control]="templateForm.controls.configurationType"></app-error-messages>
    </div>
  </div>
</form>
<app-field-assignments-form [fieldAssignmentsForm]="templateForm" [showTemplateButtons]="false"></app-field-assignments-form>
